module.exports = __webpack_public_path__ + "media/mypage/images/flat/office-block-5373dc63645d2c5d9cb976b4656eb777.png";